<template>
  <div class='refund'>
    <div class="tabBar">
      <div :class="['fl', {'active': isShow}]" @click="switchStatus('total')"><p>退全部商品</p></div>
      <div :class="['fl', {'active': !isShow}]" @click="switchStatus('part')"><p>退部分商品</p></div>
      <span class="triangle"></span>
    </div>
    <div class="goods-info" style="padding: 0.3rem 0.2rem;">
      <h3>退款商品</h3>
      <ul>
        <li v-for="item in goodsList">
          <div style="overflow: hidden">
            <div class="fl" style="width: 70%;display: flex">
              <div class="goodImg" :style="{backgroundImage:'url('+item.picAddr+')'}"></div>
              <div class="goodsInfo">
                <span class="goods-name">{{ item.title }}</span>
                <span style="font-size: .24rem;color: #999" v-if="item.attribute">{{ item.attribute }}</span>
                <span>x{{ item.number }}</span>
              </div>
            </div>
            <div class="fr"
                 style="width: 30%;height:1rem; display: flex;flex-direction: column;justify-content: space-between">
              <span style="display: flex;justify-content: flex-end;color:#333;">实付：￥{{ item.realAmount }}</span>
              <div style="display: flex;justify-content: flex-end" v-if="!isShow">
                <span @click="subtractGoods(item)" class="operatorBtn minus" v-show="item.showRefundNum"></span>
                <span class="operatorBtn number" v-show="item.showRefundNum">{{ item.refundNumber }}</span>
                <span @click="addRefundGoods(item)" class="operatorBtn plus"></span>
              </div>
            </div>
          </div>
          <!--加料属性商品-->
          <div style="padding-top: .2rem; overflow: hidden" v-for="attr in item.attributeGoodsList">
            <div class="fl" style="width: 70%;display: flex">
              <div class="goodImg">
                <img src="../assets/images/attr-img.png" alt="">
              </div>
              <div class="goodsInfo">
                <span class="goods-name">{{ attr.title }}</span>
                <span>x{{ attr.number }}</span>
              </div>
            </div>
            <div class="fr"
                 style="width: 30%;height:1rem; display: flex;flex-direction: column;justify-content: space-between">
              <span style="display: flex;justify-content: flex-end;color:#333;">实付：￥{{ attr.realAmount }}</span>
              <div style="display: flex;justify-content: flex-end" v-if="!isShow">
                <span @click="subtractGoods(item,attr)" class="operatorBtn minus" v-show="attr.showRefundNum"></span>
                <span class="operatorBtn number" v-show="attr.showRefundNum">{{ attr.refundNumber }}</span>
                <span @click="addRefundGoods(item,attr)" class="operatorBtn plus"></span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="totalGoodList.length>2 ">
        <div @click="openList" class="more ac" v-if="showMore==true"><span>查看更多</span><span class="arrow-down"
                                                                                            style="background-size: 0.14rem 0.08rem;"></span>
        </div>
        <div @click="closeList" class="more ac" v-else><span>收起</span><span class="arrow-up"></span></div>
      </div>
    </div>
    <div class="refund-reason">
      <ul>
        <li @click="showReasonBox" class="arrow-right clearflow" style="padding-right: 0.3rem;">
          <h3 class="fl">退款原因</h3>
          <div class="fr">{{ refundReason.reasonDesc }}</div>
        </li>
        <li class="flex-row-bc make-call" v-if="refundReason.responsibleDesc">
          <div>{{refundReason.responsibleDesc}}</div>
          <a :href="'tel:'+ refundReason.responsibleTel" class="btn btn-yellow fs-24" style="padding: .1rem">{{refundReason.responsibleBtn}}</a>
        </li>
        <li style="border-bottom: none;">
          <div style="width: 100%;height: 1.06rem;padding: 0.2rem;background: #F8F8F8;">
            <textarea v-model="content" placeholder="请输入详细信息以便更快帮您处理（必填）"></textarea>
          </div>
        </li>
      </ul>
    </div>
    <!--上传图片-->
    <div class="upLoadPicture" style="padding-top: 0.3rem">
      <div class="clearflow"><h3 class="fl">上传图片</h3><span class="tips">(上传照片作为凭证，退款申请被同意的概率更大)</span></div>
      <div class="addPic">
        <ul class="fl">
          <li class="fl upLoadPic" v-for="(item) in goodsImages">
            <div v-bind:style="{backgroundImage: 'url('+item+')'}"></div>
            <span @click="deletepic(item)"></span>
          </li>
        </ul>
        <div class="addPicBtn fl" v-show="isAddShow">
          <form id='uploadForm' method="post" enctype="multipart/form-data"><input type="file" id="uploadImg"
                                                                                   accept="image/*"
                                                                                   v-on:change="getImage($event)"/>
          </form>
        </div>
      </div>
    </div>
    <div v-show="flag" class="complaints_reason_select" @click="hiddenList(2)">
      <div class="reason-box">
        <div class="title">请选择退款原因</div>
        <div class="content" v-for="(item,index) in reasonList" :key="index">
          <div class="name">{{ item.name }}</div>
          <div class="item" v-for="(item1,index1) in item.list" :key="index1" @click='handleClick(item1,index1)' v-bind:class='{on:item1.isDefault==1}'>
            {{ item1.reasonDesc }}
            <span class="icon_selected"></span>
          </div>
        </div>
      </div>
    </div>
    <footer class="fixed">
      <div class="footer-con fl flexcol" style="justify-content: center" v-if="isShow">
        <p class="save" style="color: #F4576A">
          <span style="font-size: 0.36rem;font-weight: bold">￥{{ refundAmount }}</span>
          <span style="font-size: 0.28rem">(原路返回)</span>
        </p>
        <p class="tips">{{ refundDetail.totalRefundDesc }}</p>
      </div>
      <div class="footer-con fl flexcol" style="justify-content: center" v-else>
        <p class="save" style="color: #F4576A">
          <span style="font-size: 0.36rem;font-weight: bold">￥{{ refundAmount }}</span>
          <span style="font-size: 0.28rem">(原路返回)</span>
        </p>
        <p class="tips">{{ refundDetail.partRefundDesc }}</p>
      </div>

      <div class="footer-con fr flexcol" style="justify-content: center">
        <a @click="submit" class="btn btn-yellow" v-if="canSubmit">提交</a>
        <a class="btn btn-gray" v-else>提交</a>
      </div>
    </footer>
  </div>
</template>

<script>
import {actions} from '../store/actions'
import PreviewPicture from "../components/PreviewPicture"
// import { Indicator,Toast,MessageBox } from 'mint-ui'

export default {
  data() {
    return {
      orderId: window.localStorage.getItem('orderCode'),
      isAddShow: true, //控制上传图片按钮
      userTel: '',
      shopName: '',
      content: '',
      goodsImages: [],
      isRefund: false,
      shortGoodsList: [],
      totalGoodList: [],
      goodsList: [],
      isShow: true,
      showTotal: true,
      showPart: false,
      showMore: true,
      refundGoodList: [],
      flag: false, //是否显示选择退款理由弹框
      reasonList: [],
      // reason: '请选择',//退款理由
      // reasonCode: '',
      refundReason: {
        reasonDesc: '请选择',
        reasonCode: null,
      },
      refundAmountTotal: '',//全部退款金额
      refundAmount: 0,
      canSubmit: true,

      packingGoodsList: [], // 打包费
      refundDetail: {}
    }
  },
  computed: {
    wxUid() {
      return this.$store.state.wxUid
    }
  },
  // created () {
  //   document.title = "申请退款";
  // },
  mounted() {
    var _this = this;
    _this.getRefundInfo();
  },
  methods: {
    // 切换配送方式
    switchStatus: function (status) {
      var _this = this
      _this.isCanSubmit = false
      if (status === 'total') {
        _this.showTake = true
        _this.showSelf = false
        _this.isShow = true
        _this.showMore = true
        _this.goodsList = _this.shortGoodsList
        _this.refundAmount = _this.refundAmountTotal

      } else if (status === 'part') {
        _this.refundGoodList = []
        _this.refundAmount = 0
        _this.showSelf = true
        _this.showTake = false
        _this.isShow = false
        _this.showMore = true
        // _this.goodsList = _this.totalGoodList
        _this.goodsList = _this.shortGoodsList
        for (var i = 0; i < _this.goodsList.length; i++) {
          _this.goodsList[i].showRefundNum = false
          _this.goodsList[i].refundNumber = 0
        }


      }
    },
    openList: function () {
      this.goodsList = this.totalGoodList
      this.showMore = false
    },
    closeList: function () {
      this.goodsList = this.shortGoodsList
      this.showMore = true
    },
    addRefundGoods: function (item, attr) {
      var _this = this
      if (attr) {
        // 加料属性
        for (let v of _this.goodsList) {
          if (item.id == v.id && v.attributeGoodsList && v.attributeGoodsList.length > 0) {
            for (let v2 of v.attributeGoodsList) {
              if (v2.id == attr.id) {
                if (v2.refundNumber < v2.number) {
                  v2.showRefundNum = true;
                  v2.refundNumber++;
                }
              }
            }
          }
        }
      } else {
        console.log(_this.goodsList)
        for (var i = 0; i < _this.goodsList.length; i++) {
          if (_this.goodsList[i].id == item.id) {
            if (item.refundNumber < item.number) {
              _this.goodsList[i].showRefundNum = true
              _this.goodsList[i].refundNumber++
              // 同步加料属性
              console.log(_this.goodsList[i])
              let attributeGoodsList = _this.goodsList[i].attributeGoodsList;
              if (attributeGoodsList && attributeGoodsList.length > 0) {
                for (let v of attributeGoodsList) {
                  if (v.refundNumber < v.number) {
                    v.showRefundNum = true;
                    v.refundNumber++;
                  }
                }
              }
            }
          }
        }
      }
      _this.calculateRefund()
    },
    subtractGoods: function (item, attr) {
      var _this = this
      if (attr) {
        // 加料属性
        for (let v of _this.goodsList) {
          if (item.id == v.id && v.attributeGoodsList && v.attributeGoodsList.length > 0) {
            for (let v2 of v.attributeGoodsList) {
              if (v2.id == attr.id) {
                if (v2.refundNumber > 0) {
                  v2.showRefundNum = true;
                  v2.refundNumber--;
                  if (v2.refundNumber == 0) {
                    v2.showRefundNum = false
                  }
                  if (v.refundNumber > v2.refundNumber) {
                    v.refundNumber = v2.refundNumber;
                    if (v.refundNumber == 0) {
                      v.showRefundNum = false
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        for (var i = 0; i < _this.goodsList.length; i++) {
          if (_this.goodsList[i].id == item.id) {
            // 加料属性
            if (_this.goodsList[i].attributeGoodsList && _this.goodsList[i].attributeGoodsList.length > 0) {
              for (let v of _this.goodsList[i].attributeGoodsList) {
                if (item.refundNumber > 0) {
                  v.showRefundNum = true
                  v.refundNumber--
                  if (v.refundNumber == 0) {
                    v.showRefundNum = false
                  }
                }
              }
            }
            if (item.refundNumber > 0) {
              _this.goodsList[i].showRefundNum = true
              _this.goodsList[i].refundNumber--
              if (_this.goodsList[i].refundNumber == 0) {
                _this.goodsList[i].showRefundNum = false
              }
            }
          }
        }
      }
      _this.calculateRefund()
    },
    // 部分退款计算退款金额
    calculateRefund: function () {
      this.refundAmount = 0;
      let num = 0;
      for (var i = 0; i < this.goodsList.length; i++) {
        let itemAmount = parseFloat(this.goodsList[i].amount) * parseInt(this.goodsList[i].refundNumber) / parseInt(this.goodsList[i].number);
        // 加料属性价格
        let attributeGoodsList = this.goodsList[i].attributeGoodsList,
          attrAmount = 0;
        if(attributeGoodsList && attributeGoodsList.length > 0){
          for(let v of attributeGoodsList){
            let price = parseFloat(v.amount) * parseInt(v.refundNumber) / parseInt(v.number);
            attrAmount += parseFloat((Math.round(price * 100) / 100).toFixed(2));
          }
        }
        this.refundAmount += parseFloat((Math.round((itemAmount + attrAmount) * 100) / 100).toFixed(2));
        if (this.goodsList[i].refundNumber == this.goodsList[i].number) {
          num++;
        }
      }
      if (this.packingGoodsList && this.packingGoodsList.length > 0) {
        // 有打包费
        for (var j = 0; j < this.packingGoodsList.length; j++) {
          this.packingGoodsList[j].refundNumber = 0;
          this.packingGoodsList[j].originNumber = 0;
          let goodsId = this.packingGoodsList[j].goodsId;
          for (var i = 0; i < this.goodsList.length; i++) {
            if (goodsId == this.goodsList[i].goodsId) {
              this.packingGoodsList[j].refundNumber += parseInt(this.goodsList[i].refundNumber);
              this.packingGoodsList[j].originNumber += parseInt(this.goodsList[i].number);
            }
          }
          if (this.packingGoodsList[j].refundNumber > 0) {
            if (this.packingGoodsList[j].refundNumber == this.packingGoodsList[j].originNumber) {
              this.refundAmount += parseFloat(this.packingGoodsList[j].amount);
            } else {
              let packFeeNum = Math.floor(parseInt(this.packingGoodsList[j].refundNumber) / (this.packingGoodsList[j].packingFeeRule));
              let itemAmount = packFeeNum * parseFloat(this.packingGoodsList[j].amount) / parseInt(this.packingGoodsList[j].number);
              this.refundAmount += parseFloat((Math.round(itemAmount * 100) / 100).toFixed(2));
            }

          }
        }
      }
      if (num == this.goodsList.length) {
        this.refundAmount = this.refundAmountTotal;
      } else {
        this.refundAmount = this.refundAmount.toFixed(2);
      }

      // console.log(this.refundAmount)
    },
    //显示退款理由
    showReasonBox: function () {
      this.flag = true
    },
    // 选择退款理由
    handleClick: function (item, index) {
      console.log(item)
      this.refundReason = item;
      this.flag = false
      this.reasonList.forEach((val)=>{
        if(val.list){
          val.list.forEach((val1)=>{
            val1.isDefault = 0;
            if(val1.reasonCode === item.reasonCode && val.name === item.responsibleParty){
              val1.isDefault = 1;
            }
          })
        }
      })
    },
    getRefundInfo: function () {
      var _this = this
      var params = {
        orderId: _this.orderId
      }
      _this.$indicator.open();//loading
      actions.getApplyRefund(_this, params, function (data) {
        _this.$indicator.close();
        if(data.refundApplyReasonList){
          let refundApplyReasonList = data.refundApplyReasonList,
          array = [];
          let obj = refundApplyReasonList.reduce((acc, obj) => {
            var key = obj['responsibleParty'];
            if (!acc[key]) {
              acc[key] = [];
            }
            obj.checked = false;
            acc[key].push(obj);
            return acc;
          }, {});
          for(let k in obj){
            array.push({name: k, list: obj[k]});
          }
          _this.reasonList = array;
        }
        for (var i = 0; i < data.goodsList.length; i++) {
          data.goodsList[i].showRefundNum = false
          data.goodsList[i].refundNumber = 0
          let attributeGoodsList = data.goodsList[i].attributeGoodsList;
          if (attributeGoodsList && attributeGoodsList.length > 0) {
            for (let v of attributeGoodsList) {
              v.showRefundNum = false;
              v.refundNumber = 0;
            }
          }
        }
        _this.totalGoodList = data.goodsList
        _this.refundAmountTotal = data.amount
        _this.refundAmount = _this.refundAmountTotal
        _this.packingGoodsList = data.packingGoodsList || []
        _this.refundDetail = data;

        if (data.goodsList.length > 2) {
          _this.shortGoodsList = data.goodsList.slice(0, 2)
        } else {
          _this.shortGoodsList = data.goodsList
        }
        _this.goodsList = _this.shortGoodsList
      }, function (data) {
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '')
      })
    },
    selectReason: function () {
      this.flag = !this.flag
    },
    //点击空白处隐藏理由列表弹框
    hiddenList: function (index) {
      if (index == 1) {
        this.flag1 = false
      }
      if (index == 2) {
        this.flag = false
      }
    },
    //上传图片
    getImage: function (e) {
      var _this = this
      let host = _this.$utils.getSpliceHost('manager-center')
//          if(process.env.NODE_ENV=='local'){
//            host = 'http://manager-center.imcoming.com.cn'
//          }else if(process.env.NODE_ENV=='development'){
//            host = 'http://manager-center.imcoming.com.cn'
//          }else if(process.env.NODE_ENV=='test'){
//            host = 'http://manager-center.imcoming.com'
//          }else{
//            host = 'https://manager-center.anlaiye.com'
//          }
      var url = host + '/api/fileupload/upBase64'
      let file = e.target.files[0];
      if (!/image\/\w+/.test(file.type)) {
        _this.$messagebox.alert("请选择图片", '');
        return false;
      }
      _this.$indicator.open();//loading
      // 通过canvas压缩图片
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var img = new Image;
      reader.onload = function (e) {
        var width = 320, //图像大小
          quality = 0.8, //图像质量
          canvas = document.createElement("canvas"),
          drawer = canvas.getContext("2d");
        img.src = this.result;
        img.onload = function () {
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
          let imgsrc = canvas.toDataURL("image/png", quality);
          _this.$http.post(url, {src: imgsrc}, {emulateJSON: true}).then(function (response) {
            _this.goodsImages.push(response.body.data.path)
            if (_this.goodsImages.length >= 3) {
              _this.isAddShow = !_this.isAddShow
            }
            // _this.loading = false;
            _this.$indicator.close();
            // 响应成功回调
          }, function (response) {
            // 响应错误回调
            _this.$indicator.close();
          })
        }
      }
    },
    // 删除图片
    deletepic: function (index) {
      var _this = this
      _this.goodsImages.splice(index, 1)
      if (!_this.isAddShow) {
        _this.isAddShow = !_this.isAddShow
      }
    },
    //提交投诉
    submit: function () {
      var _this = this
      if (_this.isShow) {
        _this.refundGoodList = _this.totalGoodList
      } else {
        let refundGoodList = [];
        for(let v of _this.goodsList) {
          if (v.refundNumber > 0) {
            refundGoodList.push({
              id: v.id,
              goodsSaleId: v.goodsSaleId,
              number: v.refundNumber
            })
          }
          if (v.attributeGoodsList && v.attributeGoodsList.length > 0) {
            for (let v1 of v.attributeGoodsList) {
              if (v1.refundNumber > 0) {
                refundGoodList.push({
                  id: v1.id,
                  goodsSaleId: v1.goodsSaleId,
                  number: v1.refundNumber
                })
              }
            }
          }
        }
        _this.refundGoodList = refundGoodList;
      }
      if (this.refundGoodList.length < 1) {
        this.$toast('请选择需要退款的商品')
        return
      }
      if (!this.refundReason.reasonCode) {
        this.$toast('请选择退款原因')
        return
      }
      if (this.refundReason.textNeed === 1 && !this.content) {
        this.$toast('请填写详细描述')
        return
      }
      if (this.refundReason.pictureNeed === 1 && this.goodsImages.length == 0) {
        this.$toast('请上传图片')
        return
      }
      // console.log(_this.refundGoodList,"提交退款时")
      _this.$messagebox.confirm('退款将在审核通过后3-5个工作日内原路返回您的支付账户', '确认提交退款申请吗?').then(function (action) {
        var params = {
          orderId: _this.orderId,
          complaintContent: _this.content,
          complaintImages: _this.goodsImages,
          reasonCode: _this.refundReason.reasonCode,
          goodsList: _this.refundGoodList,
          isApplyRefund: 1
        }
        if (_this.canSubmit) {
          actions.postSaveComplaint(_this, params, function () {
            _this.canSubmit = false
            _this.$messagebox.alert('提交成功', '').then(function (action) {
              _this.$router.go(-1);
            });
          }, function (data) {
            _this.$messagebox.alert(data.body.message, '')
          })
        }

      })
    }
  },
  components: {
    PreviewPicture
  }
}
</script>
<style scoped>
.refund-reason .make-call{
  font-size: .24rem;
  color: #FA5151;
}
.refund-reason .make-call .btn{
  border-radius: .4rem;
}
.complaints_reason_select .reason-box{
  width: 100%;
  max-height: 80%;
  background: #fff;
  padding: 0 0.46rem;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: .22rem .22rem 0 0;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.complaints_reason_select .reason-box .title{
  font-size: .27rem;
  font-weight: bold;
  text-align: center;
  padding: .3rem 0;
}
.complaints_reason_select .reason-box .content{
  padding: 0;
}
.complaints_reason_select .reason-box .name{
  font-size: .3rem;
  padding-bottom: .4rem;
}
.complaints_reason_select .reason-box .item{
  position: relative;
  color: rgba(102,102,102,0.9);
  font-size: .3rem;
  padding-bottom: .4rem;
}
.complaints_reason_select .reason-box .item.on .icon_selected{
  top: 0;
  background-image: url('../assets/images/icon_choose@2x.png');
}
</style>



// WEBPACK FOOTER //
// OnlineRefund.vue?07fe8f6d